import { type Upsell } from "@src/components/BillingSettings2026/workflow";
import { IgTypography } from "@intelligems/ig-theme";
import { IgBluePrimitives } from "@intelligems/ig-design-tokens";

export const getUpsellBanner = (upsell?: Upsell) => {
  if (!upsell) {
    return;
  }

  const {
    currentModuleCount,
    nextSavingsPct: nextDiscountTier,
    potentialSavings,
    title,
  } = upsell;
  const { amount: potentialSavingsAmount, suffix: potentialSavingsSuffix } =
    potentialSavings;

  return {
    analytics: {
      currentModuleCount,
      nextDiscountTier,
      potentialSavingsAmount,
    },
    details: (
      <IgTypography variant={"body1"} color={"text.secondary"}>
        You'd save{" "}
        <IgTypography variant={"body1"} color="success" fontWeight={700}>
          ${potentialSavingsAmount}
          {potentialSavingsSuffix}
        </IgTypography>{" "}
        across all your modules.
      </IgTypography>
    ),
    icon: "gem",
    sx: {
      backgroundColor: IgBluePrimitives[50],
      border: "none",
      borderRadius: "10px",
      maxWidth: "430px",
    },
    title,
  };
};
